// extracted by mini-css-extract-plugin
module.exports = {"root":"AgeCell_root__ffphb","badge":"AgeCell_badge__2qBIl","notViewed":"AgeCell_notViewed__wgOzD","incoming":"AgeCell_incoming__v1pCq"};